// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.shopify-geo {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #17325c;
}
.shopify-geo__header {
  flex-shrink: 0;
  margin-bottom: 10px;
}
.shopify-geo__narrative {
  margin-bottom: 12px;
}
.shopify-geo__toolbar {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
  width: 100%;
  min-width: 0;
}
.shopify-geo__main {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  container-type: inline-size;
  container-name: shopify-geo-main;
}
.shopify-geo__date-strip {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px 16px;
  flex-wrap: wrap;
  width: 100%;
  min-width: 0;
}
.shopify-geo__date-info {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1 1 220px;
  min-width: 0;
  gap: 0;
}
.shopify-geo__date-info .shopify-geo__date-info-icon {
  margin-top: 2px;
}
.shopify-geo__date-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  color: #2b74e4;
  font-size: 18px;
  line-height: 1;
  flex-shrink: 0;
}
.shopify-geo__date-range-text {
  margin: 0;
  color: #757575;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.45;
  text-align: left;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  max-width: 100%;
}
.shopify-geo__date-inputs {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex: 0 0 auto;
  min-width: 0;
}
.shopify-geo__date-inputs .organic-range-picker {
  justify-content: flex-end;
}
.shopify-geo__date-inputs .organic-range-picker__control {
  width: 200px !important;
}
.shopify-geo--filtered .shopify-geo__regions-scroll,
.shopify-geo--filtered .shopify-geo__regions-grid--single {
  width: 100%;
  max-width: none;
  margin: 0;
}
.shopify-geo__active-filters {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px 12px;
  padding: 10px 12px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f4f7fc 0%, #eef3f9 100%);
  border: 1px solid #c5d4eb;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(13, 47, 121, 0.06);
}
.shopify-geo__active-filters-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex: 0 0 auto;
  padding-bottom: 0;
  border-bottom: none;
}
.shopify-geo__active-filters-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #17325c;
}
.shopify-geo__active-filters-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex: 1 1 280px;
  min-width: 0;
  flex-wrap: wrap;
}
.shopify-geo__active-filters-pills {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  flex: 1 1 180px;
  min-width: 0;
}
.shopify-geo__filter-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.3;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #d6e2f2;
  background: #ffffff;
  color: #17325c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.shopify-geo__filter-pill svg {
  flex-shrink: 0;
  opacity: 0.85;
}
.shopify-geo__filter-pill--region {
  color: #2b74e4;
  border-color: rgba(43, 116, 228, 0.35);
  background: rgba(43, 116, 228, 0.08);
}
.shopify-geo__filter-pill--city {
  color: #1a5f4a;
  border-color: rgba(18, 184, 134, 0.35);
  background: rgba(18, 184, 134, 0.08);
}
.shopify-geo__filter-pill--time {
  color: #6b4c9a;
  border-color: rgba(141, 79, 211, 0.35);
  background: rgba(141, 79, 211, 0.08);
}
.shopify-geo__filter-pill--loading {
  color: #5a6f8f;
  border-style: dashed;
  background: rgba(255, 255, 255, 0.72);
}
.shopify-geo__filter-pill-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  padding: 0;
  margin-left: 2px;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.6;
  color: inherit;
  transition: opacity 0.15s, background 0.15s;
}
.shopify-geo__filter-pill-remove:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.1);
}
.shopify-geo__active-filters-value {
  flex: 1 1 160px;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #2b74e4;
  line-height: 1.4;
  padding: 6px 10px;
  background: #ffffff;
  border: 1px solid #d6e2f2;
  border-radius: 6px;
}
.shopify-geo__active-filters-reset {
  flex-shrink: 0;
  border: 1px solid #2b74e4;
  background: #2b74e4;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  padding: 8px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}
.shopify-geo__active-filters-reset:hover {
  background: #5d97ee;
  border-color: #5d97ee;
}
.shopify-geo__active-filters-reset:focus {
  outline: 2px solid rgba(43, 116, 228, 0.35);
  outline-offset: 2px;
}
.shopify-geo__active-filters-reset:active {
  transform: scale(0.98);
}
.shopify-geo__regions-scroll {
  overflow-x: visible;
  padding-bottom: 8px;
  width: 100%;
  min-width: 0;
}
.shopify-geo__regions-scroll--single {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-width: 0;
}
.shopify-geo__regions-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-flow: row;
  grid-auto-columns: auto;
  grid-auto-rows: 1fr;
  gap: 8px;
  width: 100%;
  min-width: 0;
  align-items: stretch;
}
.shopify-geo__regions-grid--single {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  gap: 12px;
}
.shopify-geo__regions-grid--single > .shopify-geo__region {
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
}
.shopify-geo__error {
  padding: 12px 16px;
  margin: 12px 0;
  background: #fde8e8;
  border: 1px solid #f5c2c2;
  color: #cc4a44;
  font-size: 12px;
  border-radius: 4px;
}
@media (max-width: 1280px) {
  .shopify-geo__regions-grid:not(.shopify-geo__regions-grid--single) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 960px) {
  .shopify-geo__regions-grid:not(.shopify-geo__regions-grid--single) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.shopify-geo__region {
  background: #e8ebee;
  border: 1px solid #dde1e4;
  padding: 6px;
  display: grid;
  grid-template-rows: auto auto auto auto minmax(0, 1fr);
  gap: 8px;
  align-content: start;
  min-width: 0;
  height: 100%;
  overflow: visible;
  position: relative;
  z-index: 1;
  container-type: inline-size;
  container-name: geo-region;
}
.shopify-geo__region:hover {
  z-index: 6;
}
.shopify-geo__region--focused {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-color: #c5d4eb;
  box-shadow: 0 2px 10px rgba(43, 116, 228, 0.1);
  padding: 10px;
  gap: 10px;
  background: #eef1f4;
  width: 100%;
  min-width: 0;
}
.shopify-geo__region--focused .shopify-geo__region-top,
.shopify-geo__region--focused .shopify-geo__metrics-grid,
.shopify-geo__region--focused .shopify-geo__panels-row {
  width: 100%;
  min-width: 0;
}
.shopify-geo__region--focused .shopify-geo__metrics-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}
.shopify-geo__region--focused .shopify-geo__metric-card {
  min-height: 92px;
  min-width: 0;
  padding: 8px;
}
.shopify-geo__region--focused .shopify-geo__metric-card:last-child:nth-child(odd) {
  grid-column: auto;
}
.shopify-geo__region--focused .shopify-geo__panels-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  align-items: stretch;
}
.shopify-geo__region--focused .shopify-geo__panel {
  min-height: 0;
  height: 100%;
  min-width: 0;
}
.shopify-geo__region--focused .shopify-geo__city-map {
  height: 100%;
  min-height: 260px;
}
.shopify-geo__region--focused .shopify-geo__city-map--maplibre {
  height: 100%;
}
.shopify-geo__region--focused .shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo,
.shopify-geo__region--focused .shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo .followers-maplibre__canvas {
  min-height: 260px;
  height: 100%;
}
.shopify-geo__region--focused .shopify-geo__heatmap-wrap {
  flex: 1 1 auto;
  min-height: 0;
}
.shopify-geo__region--focused .shopify-geo__panel h4 {
  margin-bottom: 10px;
}
.shopify-geo__region--focused .shopify-geo__panel-title-text {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}
.shopify-geo__region--focused .shopify-geo__product-bars-block {
  min-height: 0;
  height: 100%;
  margin-top: 0;
  justify-content: flex-start;
}
.shopify-geo__panels-row {
  display: contents;
}
.shopify-geo__region-top {
  display: flex;
  align-items: center;
  gap: 7px;
  padding-bottom: 6px;
  border-bottom: 1px solid #c6c9cd;
}
.shopify-geo__region-top h3 {
  margin: 0;
  font-size: 12px !important;
  font-weight: 400;
  color: #5a5e62;
}
.shopify-geo__region-top .definition-tooltip {
  margin-left: auto;
  flex: 0 0 auto;
}
.shopify-geo__region-top--filtered {
  align-items: flex-start;
  padding-bottom: 8px;
}
.shopify-geo__region-heading {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  min-width: 0;
  flex: 1 1 auto;
}
.shopify-geo__region-heading h3 {
  margin: 0;
  font-size: 15px !important;
  font-weight: 600 !important;
  color: #17325c;
  line-height: 1.25;
  overflow-wrap: anywhere;
}
.shopify-geo__region-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #4a6282;
  background: rgba(43, 116, 228, 0.1);
  border: 1px solid rgba(43, 116, 228, 0.22);
  border-radius: 999px;
  padding: 2px 8px;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shopify-geo__region-badge--time {
  color: #6b4c9a;
  background: rgba(141, 79, 211, 0.1);
  border-color: rgba(141, 79, 211, 0.24);
}
.shopify-geo__region-icon {
  width: 34px;
  height: 34px;
  background: #2b74e4;
  opacity: 0.95;
  flex-shrink: 0;
}
.shopify-geo__region-icon--punjab {
  clip-path: polygon(33% 4%, 58% 10%, 76% 24%, 93% 44%, 87% 64%, 68% 82%, 40% 95%, 18% 92%, 7% 72%, 16% 56%, 11% 36%, 24% 14%);
}
.shopify-geo__region-icon--sindh {
  clip-path: polygon(37% 7%, 60% 10%, 74% 22%, 79% 42%, 72% 59%, 74% 79%, 57% 87%, 34% 86%, 24% 68%, 19% 47%, 23% 24%);
}
.shopify-geo__region-icon--balochistan {
  clip-path: polygon(11% 36%, 30% 43%, 50% 40%, 66% 33%, 84% 25%, 92% 37%, 87% 57%, 68% 64%, 47% 69%, 27% 68%, 13% 58%);
}
.shopify-geo__region-icon--kpk {
  clip-path: polygon(42% 5%, 61% 11%, 77% 24%, 76% 42%, 64% 53%, 62% 70%, 51% 88%, 35% 86%, 28% 70%, 17% 57%, 19% 34%, 28% 16%);
}
.shopify-geo__region-icon--ajk {
  clip-path: polygon(38% 5%, 55% 10%, 72% 23%, 91% 45%, 84% 66%, 61% 80%, 41% 94%, 31% 85%, 29% 70%, 16% 54%, 21% 35%, 27% 17%);
}
.shopify-geo__region-icon--others {
  border-radius: 8px;
  clip-path: none;
  background: #8a96a8;
}
.shopify-geo__metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
  width: 100%;
  min-width: 0;
}
.shopify-geo__metric-card {
  background: #ffffff;
  border-radius: 7px;
  padding: 6px;
  min-height: 96px;
  min-width: 0;
  overflow: visible;
  position: relative;
}
.shopify-geo__metric-card:last-child:nth-child(odd) {
  grid-column: 1/-1;
}
.shopify-geo__metric-card:last-child:nth-child(odd) .shopify-geo__spark-wrap svg {
  height: 34px;
}
.shopify-geo__metric-card:hover, .shopify-geo__metric-card:focus-within {
  z-index: 7;
}
.shopify-geo__metric-card--selectable {
  cursor: pointer;
  outline: 1px solid transparent;
  transition: outline-color 0.15s ease, box-shadow 0.15s ease;
}
.shopify-geo__metric-card--selectable:hover {
  outline-color: rgba(43, 116, 228, 0.35);
}
.shopify-geo__metric-card--selectable:focus {
  outline: 2px solid rgba(43, 116, 228, 0.35);
  outline-offset: 1px;
}
.shopify-geo__metric-card--active {
  outline-color: #2b74e4;
  box-shadow: 0 0 0 1px #2b74e4;
}
.shopify-geo__metric-title {
  margin: 0;
  color: #17325c;
  font-size: 11px;
  font-weight: 600;
}
.shopify-geo__metric-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 4px;
  min-width: 0;
}
.shopify-geo__metric-title-row .definition-tooltip {
  flex: 0 0 auto;
}
.shopify-geo__metric-value {
  margin: 2px 0;
  font-size: 12px;
  color: #17325c;
  line-height: 1.1;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.shopify-geo__metric-delta {
  margin: 0;
  font-size: 8px;
  font-weight: 600;
}
.shopify-geo__metric-delta--positive {
  color: #49904a;
}
.shopify-geo__metric-delta--negative {
  color: #cc4a44;
}
.shopify-geo__spark-wrap {
  margin-top: 4px;
  position: relative;
  overflow: hidden;
}
.shopify-geo__spark-wrap svg {
  width: 100%;
  height: 28px;
  display: block;
  overflow: hidden;
  shape-rendering: geometricPrecision;
}
.shopify-geo__spark-line {
  fill: none;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.shopify-geo__spark-vertex {
  pointer-events: none;
}
.shopify-geo__spark-vertex--previous {
  fill: rgba(148, 208, 181, 0.32);
  stroke: #94d0b5;
  stroke-width: 0.35;
}
.shopify-geo__spark-vertex--current {
  fill: #2b74e4;
  stroke: #8d4fd3;
  stroke-width: 0.35;
}
.shopify-geo__spark-line--previous {
  stroke: #94d0b5;
}
.shopify-geo__spark-line--current {
  stroke: #2b74e4;
}
.shopify-geo__spark-dot {
  stroke-width: 1.5;
}
.shopify-geo__spark-dot--previous {
  fill: rgba(148, 208, 181, 0.22);
  stroke: #94d0b5;
}
.shopify-geo__spark-dot--current {
  fill: #2b74e4;
  stroke: #8d4fd3;
}
.shopify-geo__panel {
  background: #ffffff;
  border: 1px solid #dde1e4;
  padding: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
  min-height: 0;
  height: 100%;
}
.shopify-geo__panel h4 {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 400;
  color: #4d545e;
  min-height: 24px;
  line-height: 1.25;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: 6px;
  width: 100%;
  margin-bottom: 15px;
}
.shopify-geo__panel-title-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shopify-geo__region:last-child .definition-tooltip__popover {
  left: auto;
  right: 0;
}
.shopify-geo__city-map {
  height: 170px;
  position: relative;
  overflow: hidden;
  background: #ffffff;
}
.shopify-geo__city-map--maplibre {
  border: 1px solid #e6ebf2;
  border-radius: 4px;
}
.shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo,
.shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo .followers-maplibre__canvas {
  min-height: 170px;
  height: 100%;
}
.shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo {
  border-radius: 4px;
  box-shadow: none;
}
.shopify-geo__city-map--maplibre .maplibregl-ctrl-top-right {
  top: 6px;
  right: 6px;
}
.shopify-geo__city-map--not-available {
  width: 170px;
  max-width: 100%;
  margin: 0 auto;
  border: 1px dashed #c6cfdc;
  border-radius: 4px;
  background: #f7f9fc;
  color: #6b778c;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  aspect-ratio: 1/1;
  height: auto;
  min-height: 0;
}
.shopify-geo__city-marker {
  display: block;
  border-radius: 999px;
  background: rgba(148, 208, 181, 0.28);
  border: 2px solid #94d0b5;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.45);
  cursor: pointer;
}
.shopify-geo__blob {
  width: 86%;
  height: 88%;
  margin: 12px auto 0;
  background: #2b74e4;
  clip-path: polygon(11% 75%, 21% 56%, 15% 36%, 27% 20%, 44% 13%, 63% 16%, 79% 27%, 92% 45%, 86% 66%, 72% 83%, 52% 94%, 31% 91%);
}
.shopify-geo__blob--all {
  clip-path: polygon(33% 4%, 58% 10%, 76% 24%, 93% 44%, 87% 64%, 68% 82%, 40% 95%, 18% 92%, 7% 72%, 16% 56%, 11% 36%, 24% 14%);
}
.shopify-geo__blob--punjab {
  clip-path: polygon(33% 4%, 58% 10%, 76% 24%, 93% 44%, 87% 64%, 68% 82%, 40% 95%, 18% 92%, 7% 72%, 16% 56%, 11% 36%, 24% 14%);
}
.shopify-geo__blob--sindh {
  clip-path: polygon(37% 7%, 60% 10%, 74% 22%, 79% 42%, 72% 59%, 74% 79%, 57% 87%, 34% 86%, 24% 68%, 19% 47%, 23% 24%);
}
.shopify-geo__blob--balochistan {
  clip-path: polygon(11% 36%, 30% 43%, 50% 40%, 66% 33%, 84% 25%, 92% 37%, 87% 57%, 68% 64%, 47% 69%, 27% 68%, 13% 58%);
}
.shopify-geo__blob--kpk {
  clip-path: polygon(42% 5%, 61% 11%, 77% 24%, 76% 42%, 64% 53%, 62% 70%, 51% 88%, 35% 86%, 28% 70%, 17% 57%, 19% 34%, 28% 16%);
}
.shopify-geo__blob--ajk {
  clip-path: polygon(38% 5%, 55% 10%, 72% 23%, 91% 45%, 84% 66%, 61% 80%, 41% 94%, 31% 85%, 29% 70%, 16% 54%, 21% 35%, 27% 17%);
}
.shopify-geo__bubble {
  position: absolute;
  border-radius: 50%;
  background: rgba(246, 193, 95, 0.18);
  border: 2px solid #f6c15f;
}
.shopify-geo__bubble--lg {
  width: 36px;
  height: 36px;
  right: 22%;
  top: 52%;
}
.shopify-geo__bubble--md {
  width: 20px;
  height: 20px;
  right: 36%;
  top: 24%;
}
.shopify-geo__bubble--sm {
  width: 11px;
  height: 11px;
  right: 31%;
  top: 20%;
}
.shopify-geo__heatmap-wrap {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow-x: auto;
  position: relative;
}
.shopify-geo__heat-days {
  display: grid;
  grid-template-columns: 46px repeat(7, 1fr);
  gap: 2px;
  margin-bottom: 2px;
}
.shopify-geo__heat-days span {
  font-size: 10px;
  text-align: center;
  color: #17325c;
}
.shopify-geo__heat-body {
  display: grid;
  gap: 2px;
}
.shopify-geo__heat-row {
  position: relative;
  display: grid;
  grid-template-columns: 46px repeat(7, 1fr);
  gap: 2px;
}
.shopify-geo__heat-row span {
  font-size: 9px;
  color: #17325c;
  line-height: 14px;
  text-align: right;
  padding-right: 7px;
  white-space: nowrap;
}
.shopify-geo__heat-cell {
  height: 14px;
  border-radius: 1px;
  cursor: pointer;
}
.shopify-geo__heat-cell--lv1 {
  background: rgba(43, 116, 228, 0.12);
}
.shopify-geo__heat-cell--lv2 {
  background: rgba(43, 116, 228, 0.28);
}
.shopify-geo__heat-cell--lv3 {
  background: rgba(43, 116, 228, 0.56);
}
.shopify-geo__heat-cell--lv4 {
  background: rgba(43, 116, 228, 0.88);
}
.shopify-geo__heat-cell--active {
  box-shadow: 0 0 0 2px #2b74e4;
  z-index: 1;
}
.shopify-geo__donut-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  min-height: 240px;
  height: 100%;
  justify-content: center;
}
.shopify-geo__donut-wrap {
  width: 126px;
  height: 126px;
  position: relative;
}
.shopify-geo__legend {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 6px;
  width: 100%;
  min-height: 118px;
}
.shopify-geo__donut-svg {
  width: 126px;
  height: 126px;
  display: block;
}
.shopify-geo__donut-center {
  background: #f2f4f6;
  fill: #f2f4f6;
}
.shopify-geo__donut-segment {
  cursor: pointer;
  transition: opacity 0.15s ease;
}
.shopify-geo__donut-segment:hover {
  opacity: 0.86;
}
.shopify-geo__donut-segment--selectable {
  cursor: pointer;
}
.shopify-geo__product-bars-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 170px;
  height: 100%;
  margin-top: -20px;
}
.shopify-geo__product-bars {
  display: grid;
  gap: 12px;
  width: 100%;
}
.shopify-geo__product-bar-row {
  display: grid;
  gap: 4px;
  width: 100%;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
}
.shopify-geo__product-bar-row--interactive {
  cursor: pointer;
}
.shopify-geo__product-bar-row:hover .shopify-geo__product-bar-fill, .shopify-geo__product-bar-row:focus-visible .shopify-geo__product-bar-fill {
  filter: brightness(0.95) saturate(1.1);
}
.shopify-geo__product-bar-row:focus-visible {
  outline: 2px solid rgba(43, 116, 228, 0.35);
  outline-offset: 2px;
}
.shopify-geo__product-bar-meta {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.shopify-geo__product-bar-name {
  min-width: 0;
  color: #14243f;
  font-size: 9px;
  font-weight: 700;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.shopify-geo__product-bar-meta strong {
  color: #17325c;
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
}
.shopify-geo__product-bar-track {
  display: block;
  width: 100%;
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #e9edf3;
}
.shopify-geo__product-bar-fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  transition: filter 0.15s ease;
}
.shopify-geo__product-bars-empty {
  margin: 0;
  color: #6b7280;
  font-size: 11px;
  font-weight: 600;
  text-align: center;
}
.shopify-geo__legend {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 6px;
  width: 100%;
}
.shopify-geo__legend li {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr);
  gap: 6px;
  align-items: center;
  border: 1px solid transparent;
  padding: 2px 3px;
}
.shopify-geo__legend li:hover {
  border-color: #8f8f8f;
  background: rgba(255, 255, 255, 0.35);
}
.shopify-geo__legend span {
  width: 10px;
  height: 10px;
  border-radius: 1px;
}
.shopify-geo__legend p {
  margin: 0;
  font-size: 11px;
  color: #4f5661;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.shopify-geo .followers-maplibre--shopify-geo .followers-maplibre__tooltip {
  max-width: calc(100vw - 16px);
  transform: none;
}
.shopify-geo .followers-maplibre--shopify-geo .shopify-geo-map-tooltip {
  gap: 10px;
  min-width: 70px;
  max-width: 100px;
  padding: 22px 22px 22px;
  border: 1px solid #e6ebf2;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08), 0 14px 34px rgba(15, 23, 42, 0.18);
}
.shopify-geo .shopify-geo-map-tooltip__title {
  color: #2b74e4;
  font-size: 16px;
  font-weight: 800;
  line-height: 1.15;
}
.shopify-geo .shopify-geo-map-tooltip__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  color: #7b8497;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
}
.shopify-geo .shopify-geo-map-tooltip__label {
  min-width: 0;
  white-space: nowrap;
}
.shopify-geo .shopify-geo-map-tooltip__value {
  color: #697386;
  font-weight: 800;
  white-space: nowrap;
  text-align: right;
}

.analytics-chart-tooltip {
  position: absolute;
  transform: translateX(-50%);
  display: flex;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d9e4f2;
  box-shadow: 0 8px 18px rgba(30, 42, 70, 0.18);
  overflow: hidden;
  padding: 0;
  z-index: 25;
  pointer-events: none;
}
.analytics-chart-tooltip__bar {
  width: 4px;
  background: #2b74e4;
  flex-shrink: 0;
}
.analytics-chart-tooltip__content {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.analytics-chart-tooltip__meta {
  font-size: 11px;
  color: #5a6f91;
  line-height: 1.25;
}
.analytics-chart-tooltip__meta strong {
  color: #1f2d42;
  font-weight: 700;
}

.analytics-chart-tooltip--shopify-kpi {
  position: fixed;
  transform: none;
  min-width: 220px;
  max-width: calc(100vw - 16px);
  height: auto;
}

.analytics-chart-tooltip--shopify-heatmap {
  position: fixed;
  transform: none;
  width: 220px;
  min-width: 220px;
  max-width: 220px;
  height: auto;
}

.analytics-chart-tooltip--shopify-products,
.analytics-chart-tooltip--shopify-donut {
  position: fixed;
  transform: none;
  min-width: 240px;
  max-width: 320px;
  height: auto;
}

@media (max-width: 1000px) {
  .shopify-geo__date-strip {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .shopify-geo__date-info {
    grid-column: auto;
  }
  .shopify-geo__date-info p {
    white-space: normal;
  }
  .shopify-geo__date-inputs {
    grid-column: auto;
    justify-self: start;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
  }
  .shopify-geo__date-inputs .organic-range-picker {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .shopify-geo__header h2 {
    font-size: 24px;
  }
  .shopify-geo__date-strip {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  .shopify-geo__date-inputs {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 10px;
  }
  .shopify-geo__date-info {
    justify-content: center;
    align-items: center;
    width: 100%;
    grid-column: auto;
  }
  .shopify-geo__date-info p {
    white-space: normal;
    text-align: center;
  }
  .shopify-geo__regions-grid:not(.shopify-geo__regions-grid--single) {
    grid-template-columns: 1fr;
    grid-auto-flow: row;
    grid-auto-columns: auto;
    min-width: 0;
  }
}
/* ResizeObserver-driven layout (devtools / sidebar) — reliable vs viewport media queries */
.shopify-geo__main--wide .shopify-geo__region--focused .shopify-geo__metrics-grid {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.shopify-geo__main--compact .shopify-geo__regions-grid:not(.shopify-geo__regions-grid--single) {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.shopify-geo__main--compact .shopify-geo__region--focused .shopify-geo__metrics-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.shopify-geo__main--compact .shopify-geo__region--focused .shopify-geo__panels-row {
  grid-template-columns: minmax(0, 1fr);
}
.shopify-geo__main--compact .shopify-geo__region--focused .shopify-geo__city-map {
  height: 220px;
  min-height: 220px;
}
.shopify-geo__main--compact .shopify-geo__region--focused .shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo,
.shopify-geo__main--compact .shopify-geo__region--focused .shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo .followers-maplibre__canvas {
  min-height: 220px;
  height: 220px;
}

.shopify-geo__main--stacked .shopify-geo__regions-grid:not(.shopify-geo__regions-grid--single) {
  grid-template-columns: minmax(0, 1fr);
}
.shopify-geo__main--stacked .shopify-geo__region--focused .shopify-geo__metrics-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.shopify-geo__main--stacked .shopify-geo__region--focused .shopify-geo__panels-row {
  grid-template-columns: minmax(0, 1fr);
}
.shopify-geo__main--stacked .shopify-geo__region--focused .shopify-geo__city-map {
  height: 220px;
  min-height: 220px;
}
.shopify-geo__main--stacked .shopify-geo__region--focused .shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo,
.shopify-geo__main--stacked .shopify-geo__region--focused .shopify-geo__city-map--maplibre .followers-maplibre--shopify-geo .followers-maplibre__canvas {
  min-height: 220px;
  height: 220px;
}

.shopify-geo__main--compact .shopify-geo__region:not(.shopify-geo__region--focused) .shopify-geo__metrics-grid,
.shopify-geo__main--stacked .shopify-geo__region:not(.shopify-geo__region--focused) .shopify-geo__metrics-grid {
  grid-template-columns: minmax(0, 1fr);
}

@container geo-region (max-width: 300px) {
  .shopify-geo__metrics-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .shopify-geo__metric-card:last-child:nth-child(odd) {
    grid-column: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/shopify/components/Tabs/ShopifyGeoSpatialDashboard.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAWhB;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AATF;AAWE;EACE,cAAA;EACA,mBAAA;AATJ;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAXJ;AAcE;EACE,cAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,2BAAA;EACA,gCAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAbJ;AAgBE;EACE,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,MAAA;AAdJ;AAgBI;EACE,eAAA;AAdN;AAkBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cA/EwB;EAgFxB,eAAA;EACA,cAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;AAlBJ;AAoBI;EACE,yBAAA;AAlBN;AAqBI;EACE,uBAAA;AAnBN;AAwBI;;EAEE,WAAA;EACA,eAAA;EACA,SAAA;AAtBN;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,6DAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;AA3BJ;AA8BE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;AA5BJ;AA+BE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBCnLI;EDoLJ,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7BJ;AA+BI;EACE,cAAA;EACA,aAAA;AA7BN;AAgCI;EACE,cA1MsB;EA2MtB,sCAAA;EACA,oCAAA;AA9BN;AAiCI;EACE,cAAA;EACA,sCAAA;EACA,oCAAA;AA/BN;AAkCI;EACE,cAAA;EACA,sCAAA;EACA,oCAAA;AAhCN;AAmCI;EACE,cAAA;EACA,oBAAA;EACA,qCAAA;AAjCN;AAqCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,2CAAA;AAnCJ;AAqCI;EACE,UAAA;EACA,8BAAA;AAnCN;AAuCE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cA9PwB;EA+PxB,gBAAA;EACA,iBAAA;EACA,mBCtPI;EDuPJ,yBAAA;EACA,kBAAA;AArCJ;AAwCE;EACE,cAAA;EACA,yBAAA;EACA,mBAzQwB;EA0QxB,cC/PI;EDgQJ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,+EACE;AAvCN;AA2CI;EACE,mBAlR2B;EAmR3B,qBAnR2B;AA0OjC;AA4CI;EACE,2CAAA;EACA,mBAAA;AA1CN;AA6CI;EACE,sBAAA;AA3CN;AA+CE;EACE,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA7CJ;AAgDE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;AA9CJ;AAiDE;EACE,aAAA;EACA,gDAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AA/CJ;AAkDE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAhDJ;AAkDI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAhDN;AAoDE;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eC9HW;ED+HX,kBAAA;AAlDJ;AAqDE;EACE;IACE,gDAAA;EAnDJ;AACF;AAsDE;EACE;IACE,gDAAA;EApDJ;AACF;AAuDE;EACE,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,sDAAA;EACA,QAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;EACA,0BAAA;AArDJ;AAwDE;EACE,UAAA;AAtDJ;AAyDE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8CAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAvDJ;AAyDI;;;EAGE,WAAA;EACA,YAAA;AAvDN;AA0DI;EACE,gDAAA;EACA,QAAA;AAxDN;AA2DI;EACE,gBAAA;EACA,YAAA;EACA,YAAA;AAzDN;AA4DI;EACE,iBAAA;AA1DN;AA6DI;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,oBAAA;AA3DN;AA8DI;EACE,aAAA;EACA,YAAA;EACA,YAAA;AA5DN;AA+DI;EACE,YAAA;EACA,iBAAA;AA7DN;AAgEI;EACE,YAAA;AA9DN;AAgEM;;EAEE,iBAAA;EACA,YAAA;AA9DR;AAkEI;EACE,cAAA;EACA,aAAA;AAhEN;AAmEI;EACE,mBAAA;AAjEN;AAoEI;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;AAlEN;AAqEI;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;AAnEN;AAuEE;EACE,iBAAA;AArEJ;AAwEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gCAAA;AAtEJ;AAwEI;EACE,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,cAAA;AAtEN;AAyEI;EACE,iBAAA;EACA,cAAA;AAvEN;AA2EE;EACE,uBAAA;EACA,mBAAA;AAzEJ;AA4EE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;AA1EJ;AA4EI;EACE,SAAA;EACA,0BAAA;EACA,2BAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AA1EN;AA8EE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mCAAA;EACA,0CAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA5EJ;AA8EI;EACE,cAAA;EACA,mCAAA;EACA,sCAAA;AA5EN;AAgFE;EACE,WAAA;EACA,YAAA;EACA,mBA1hBwB;EA2hBxB,aAAA;EACA,cAAA;AA9EJ;AAiFE;EACE,4HAAA;AA/EJ;AAkFE;EACE,oHAAA;AAhFJ;AAmFE;EACE,qHAAA;AAjFJ;AAoFE;EACE,6HAAA;AAlFJ;AAqFE;EACE,6HAAA;AAnFJ;AAsFE;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;AApFJ;AAuFE;EACE,aAAA;EACA,gDAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;AArFJ;AAwFE;EACE,mBCvjBI;EDwjBJ,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAtFJ;AAyFE;EACE,iBAAA;AAvFJ;AAyFI;EACE,YAAA;AAvFN;AA2FE;EAEE,UAAA;AA1FJ;AA6FE;EACE,eAAA;EACA,8BAAA;EACA,2DACE;AA5FN;AA+FI;EACE,uCAAA;AA7FN;AAgGI;EACE,2CAAA;EACA,mBAAA;AA9FN;AAkGE;EACE,sBA1mBwB;EA2mBxB,6BAAA;AAhGJ;AAmGE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjGJ;AAoGE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,YAAA;AAlGJ;AAoGI;EACE,cAAA;AAlGN;AAsGE;EACE,aAAA;EACA,eC5aW;ED6aX,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AApGJ;AAuGE;EACE,SAAA;EACA,cAAA;EACA,gBAAA;AArGJ;AAwGE;EACE,cAAA;AAtGJ;AAyGE;EACE,cAAA;AAvGJ;AA0GE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AAxGJ;AA0GI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,mCAAA;AAxGN;AA4GE;EACE,UAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;AA1GJ;AA6GE;EACE,oBAAA;AA3GJ;AA8GE;EACE,+BAAA;EACA,eAlrB0B;EAmrB1B,kBAAA;AA5GJ;AA+GE;EACE,aAxrBwB;EAyrBxB,eAtrBwB;EAurBxB,kBAAA;AA7GJ;AAgHE;EACE,eA7rB0B;AA+kB9B;AAiHE;EACE,eAlsBwB;AAmlB5B;AAkHE;EACE,iBAAA;AAhHJ;AAmHE;EACE,+BAAA;EACA,eA1sB0B;AAylB9B;AAoHE;EACE,aA/sBwB;EAgtBxB,eA7sBwB;AA2lB5B;AAqHE;EACE,mBCzsBI;ED0sBJ,yBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;AAnHJ;AAqHI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AAnHN;AAuHE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AArHJ;AAwHE;EACE,UAAA;EACA,QAAA;AAtHJ;AAyHE;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBCnvBI;AD4nBR;AA0HE;EACE,yBAAA;EACA,kBAAA;AAxHJ;AA0HI;;EAEE,iBAAA;EACA,YAAA;AAxHN;AA2HI;EACE,kBAAA;EACA,gBAAA;AAzHN;AA4HI;EACE,QAAA;EACA,UAAA;AA1HN;AA8HE;EACE,YAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AA5HJ;AA+HE;EACE,cAAA;EACA,oBAAA;EACA,qCAAA;EACA,yBAAA;EACA,+CAAA;EACA,eAAA;AA7HJ;AAgIE;EACE,UAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAxzBwB;EAyzBxB,8HAAA;AA9HJ;AAiIE;EACE,4HAAA;AA/HJ;AAkIE;EACE,4HAAA;AAhIJ;AAmIE;EACE,oHAAA;AAjIJ;AAoIE;EACE,qHAAA;AAlIJ;AAqIE;EACE,6HAAA;AAnIJ;AAsIE;EACE,6HAAA;AApIJ;AAuIE;EACE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;AArIJ;AAwIE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;AAtIJ;AAyIE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;AAvIJ;AA0IE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;AAxIJ;AA2IE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAzIJ;AA4IE;EACE,aAAA;EACA,0CAAA;EACA,QAAA;EACA,kBAAA;AA1IJ;AA4II;EACE,eC3qBS;ED4qBT,kBAAA;EACA,cAAA;AA1IN;AA8IE;EACE,aAAA;EACA,QAAA;AA5IJ;AA+IE;EACE,kBAAA;EACA,aAAA;EACA,0CAAA;EACA,QAAA;AA7IJ;AA+II;EACE,cAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AA7IN;AAiJE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;AA/IJ;AAkJE;EACE,oCAAA;AAhJJ;AAmJE;EACE,oCAAA;AAjJJ;AAoJE;EACE,oCAAA;AAlJJ;AAqJE;EACE,oCAAA;AAnJJ;AAsJE;EACE,6BAAA;EACA,UAAA;AApJJ;AAuJE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AArJJ;AAwJE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAtJJ;AAyJE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;AAvJJ;AA0JE;EACE,YAAA;EACA,aAAA;EACA,cAAA;AAxJJ;AA2JE;EACE,mBAAA;EACA,aAAA;AAzJJ;AA4JE;EACE,eAAA;EACA,8BAAA;AA1JJ;AA4JI;EACE,aAAA;AA1JN;AA8JE;EACE,eAAA;AA5JJ;AA+JE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AA7JJ;AAgKE;EACE,aAAA;EACA,SAAA;EACA,WAAA;AA9JJ;AAiKE;EACE,aAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AA/JJ;AAkKE;EACE,eAAA;AAhKJ;AAmKE;EAEE,sCAAA;AAlKJ;AAqKE;EACE,2CAAA;EACA,mBAAA;AAnKJ;AAsKE;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AApKJ;AAuKE;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArKJ;AAwKE;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAtKJ;AAyKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AAvKJ;AA0KE;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;AAxKJ;AA2KE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAzKJ;AA4KE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;AA1KJ;AA4KI;EACE,aAAA;EACA,0CAAA;EACA,QAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;AA1KN;AA4KM;EACE,qBAAA;EACA,qCAAA;AA1KR;AA8KI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA5KN;AA+KI;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7KN;AAkLE;EACE,6BAAA;EACA,eAAA;AAhLJ;AAmLE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gFACE;AAlLN;AAsLE;EACE,cA/nCwB;EAgoCxB,eAAA;EACA,gBAAA;EACA,iBAAA;AApLJ;AAuLE;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AArLJ;AAwLE;EACE,YAAA;EACA,mBAAA;AAtLJ;AAyLE;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAvLJ;;AA8LA;EACE,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBC3pCM;ED4pCN,kBAAA;EACA,yBAAA;EACA,6CAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;AA3LF;AA6LE;EACE,UAAA;EACA,mBAjrCwB;EAkrCxB,cAAA;AA3LJ;AA8LE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA5LJ;AA+LE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AA7LJ;AA+LI;EACE,cAAA;EACA,gBAAA;AA7LN;;AAkMA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;AA/LF;;AAkMA;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AA/LF;;AAkMA;;EAEE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AA/LF;;AAkMA;EAEI;IACE,0BAAA;IACA,SAAA;EAhMJ;EAmME;IACE,iBAAA;EAjMJ;EAmMI;IACE,mBAAA;EAjMN;EAqME;IACE,iBAAA;IACA,mBAAA;IACA,2BAAA;IACA,eAAA;IACA,WAAA;EAnMJ;EAqMI;IACE,WAAA;EAnMN;AACF;AAwMA;EAEI;IACE,eAAA;EAvMJ;EA0ME;IACE,aAAA;IACA,sBAAA;IACA,oBAAA;EAxMJ;EA2ME;IACE,2BAAA;IACA,eAAA;IACA,SAAA;EAzMJ;EA4ME;IACE,uBAAA;IACA,mBAAA;IACA,WAAA;IACA,iBAAA;EA1MJ;EA4MI;IACE,mBAAA;IACA,kBAAA;EA1MN;EA8ME;IACE,0BAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EA5MJ;AACF;AAgNA,2FAAA;AAEE;EACE,gDAAA;AA/MJ;;AAoNE;EACE,gDAAA;AAjNJ;AAoNE;EACE,gDAAA;AAlNJ;AAqNE;EACE,qCAAA;AAnNJ;AAsNE;EACE,aAAA;EACA,iBAAA;AApNJ;AAwNI;;EAEE,iBAAA;EACA,aAAA;AAtNN;;AA4NE;EACE,qCAAA;AAzNJ;AA4NE;EACE,gDAAA;AA1NJ;AA6NE;EACE,qCAAA;AA3NJ;AA8NE;EACE,aAAA;EACA,iBAAA;AA5NJ;AAgOI;;EAEE,iBAAA;EACA,aAAA;AA9NN;;AAqOE;;EACE,qCAAA;AAjOJ;;AAqOA;EACE;IACE,qCAAA;EAlOF;EAqOA;IACE,iBAAA;EAnOF;AACF","sourcesContent":["@import \"../../../../styles/variables\";\n\n$shopify-geo-chart-primary: #2b74e4;\n$shopify-geo-chart-secondary: #94d0b5;\n$shopify-geo-chart-tertiary: #f6c15f;\n$shopify-geo-chart-warning: #8d4fd3;\n$shopify-geo-chart-primary-soft: #5d97ee;\n$shopify-geo-chart-secondary-soft: #5abf8b;\n$shopify-geo-chart-tertiary-soft: #f0a84a;\n$shopify-geo-chart-warning-soft: #b07ae9;\n\n.shopify-geo {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  color: #17325c;\n\n  &__header {\n    flex-shrink: 0;\n    margin-bottom: 10px;\n  }\n\n  &__narrative {\n    margin-bottom: 12px;\n  }\n\n  &__toolbar {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 12px;\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__main {\n    flex: 1 1 auto;\n    min-height: 0;\n    min-width: 0;\n    width: 100%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    container-type: inline-size;\n    container-name: shopify-geo-main;\n  }\n\n  &__date-strip {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px 16px;\n    flex-wrap: wrap;\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__date-info {\n    display: flex;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex: 1 1 220px;\n    min-width: 0;\n    gap: 0;\n\n    .shopify-geo__date-info-icon {\n      margin-top: 2px;\n    }\n  }\n\n  &__date-info-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    margin-right: 10px;\n    color: $shopify-geo-chart-primary;\n    font-size: 18px;\n    line-height: 1;\n    flex-shrink: 0;\n  }\n\n  &__date-range-text {\n    margin: 0;\n    color: #757575;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 1.45;\n    text-align: left;\n    white-space: normal;\n    word-break: break-word;\n    overflow-wrap: anywhere;\n    max-width: 100%;\n  }\n\n  &__date-inputs {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    flex: 0 0 auto;\n    min-width: 0;\n\n    .organic-range-picker {\n      justify-content: flex-end;\n    }\n\n    .organic-range-picker__control {\n      width: 200px !important;\n    }\n  }\n\n  &--filtered {\n    .shopify-geo__regions-scroll,\n    .shopify-geo__regions-grid--single {\n      width: 100%;\n      max-width: none;\n      margin: 0;\n    }\n  }\n\n  &__active-filters {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 10px 12px;\n    padding: 10px 12px;\n    width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n    background: linear-gradient(180deg, #f4f7fc 0%, #eef3f9 100%);\n    border: 1px solid #c5d4eb;\n    border-radius: 8px;\n    box-shadow: 0 1px 2px rgba(13, 47, 121, 0.06);\n  }\n\n  &__active-filters-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    flex: 0 0 auto;\n    padding-bottom: 0;\n    border-bottom: none;\n  }\n\n  &__active-filters-title {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #17325c;\n  }\n\n  &__active-filters-row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    flex: 1 1 280px;\n    min-width: 0;\n    flex-wrap: wrap;\n  }\n\n  &__active-filters-pills {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n    flex: 1 1 180px;\n    min-width: 0;\n  }\n\n  &__filter-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    max-width: 100%;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.3;\n    padding: 5px 10px;\n    border-radius: 6px;\n    border: 1px solid #d6e2f2;\n    background: $white;\n    color: #17325c;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    svg {\n      flex-shrink: 0;\n      opacity: 0.85;\n    }\n\n    &--region {\n      color: $shopify-geo-chart-primary;\n      border-color: rgba(43, 116, 228, 0.35);\n      background: rgba(43, 116, 228, 0.08);\n    }\n\n    &--city {\n      color: #1a5f4a;\n      border-color: rgba(18, 184, 134, 0.35);\n      background: rgba(18, 184, 134, 0.08);\n    }\n\n    &--time {\n      color: #6b4c9a;\n      border-color: rgba(141, 79, 211, 0.35);\n      background: rgba(141, 79, 211, 0.08);\n    }\n\n    &--loading {\n      color: #5a6f8f;\n      border-style: dashed;\n      background: rgba(255, 255, 255, 0.72);\n    }\n  }\n\n  &__filter-pill-remove {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 16px;\n    height: 16px;\n    padding: 0;\n    margin-left: 2px;\n    background: none;\n    border: none;\n    border-radius: 50%;\n    cursor: pointer;\n    opacity: 0.6;\n    color: inherit;\n    transition: opacity 0.15s, background 0.15s;\n\n    &:hover {\n      opacity: 1;\n      background: rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  &__active-filters-value {\n    flex: 1 1 160px;\n    min-width: 0;\n    font-size: 13px;\n    font-weight: 600;\n    color: $shopify-geo-chart-primary;\n    line-height: 1.4;\n    padding: 6px 10px;\n    background: $white;\n    border: 1px solid #d6e2f2;\n    border-radius: 6px;\n  }\n\n  &__active-filters-reset {\n    flex-shrink: 0;\n    border: 1px solid $shopify-geo-chart-primary;\n    background: $shopify-geo-chart-primary;\n    color: $white;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 8px 14px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition:\n      background 0.15s ease,\n      border-color 0.15s ease,\n      transform 0.1s ease;\n\n    &:hover {\n      background: $shopify-geo-chart-primary-soft;\n      border-color: $shopify-geo-chart-primary-soft;\n    }\n\n    &:focus {\n      outline: 2px solid rgba(43, 116, 228, 0.35);\n      outline-offset: 2px;\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n  }\n\n  &__regions-scroll {\n    overflow-x: visible;\n    padding-bottom: 8px;\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__regions-scroll--single {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__regions-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    grid-auto-flow: row;\n    grid-auto-columns: auto;\n    grid-auto-rows: 1fr;\n    gap: 8px;\n    width: 100%;\n    min-width: 0;\n    align-items: stretch;\n  }\n\n  &__regions-grid--single {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n    min-width: 0;\n    gap: 12px;\n\n    > .shopify-geo__region {\n      width: 100%;\n      min-width: 0;\n      flex: 1 1 auto;\n      align-self: stretch;\n    }\n  }\n\n  &__error {\n    padding: 12px 16px;\n    margin: 12px 0;\n    background: #fde8e8;\n    border: 1px solid #f5c2c2;\n    color: #cc4a44;\n    font-size: $font-size-sm;\n    border-radius: 4px;\n  }\n\n  @media (max-width: 1280px) {\n    &__regions-grid:not(&__regions-grid--single) {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n    }\n  }\n\n  @media (max-width: 960px) {\n    &__regions-grid:not(&__regions-grid--single) {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n\n  &__region {\n    background: #e8ebee;\n    border: 1px solid #dde1e4;\n    padding: 6px;\n    display: grid;\n    grid-template-rows: auto auto auto auto minmax(0, 1fr);\n    gap: 8px;\n    align-content: start;\n    min-width: 0;\n    height: 100%;\n    overflow: visible;\n    position: relative;\n    z-index: 1;\n    container-type: inline-size;\n    container-name: geo-region;\n  }\n\n  &__region:hover {\n    z-index: 6;\n  }\n\n  &__region--focused {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    border-color: #c5d4eb;\n    box-shadow: 0 2px 10px rgba(43, 116, 228, 0.1);\n    padding: 10px;\n    gap: 10px;\n    background: #eef1f4;\n    width: 100%;\n    min-width: 0;\n\n    .shopify-geo__region-top,\n    .shopify-geo__metrics-grid,\n    .shopify-geo__panels-row {\n      width: 100%;\n      min-width: 0;\n    }\n\n    .shopify-geo__metrics-grid {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n      gap: 8px;\n    }\n\n    .shopify-geo__metric-card {\n      min-height: 92px;\n      min-width: 0;\n      padding: 8px;\n    }\n\n    .shopify-geo__metric-card:last-child:nth-child(odd) {\n      grid-column: auto;\n    }\n\n    .shopify-geo__panels-row {\n      display: grid;\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n      gap: 10px;\n      align-items: stretch;\n    }\n\n    .shopify-geo__panel {\n      min-height: 0;\n      height: 100%;\n      min-width: 0;\n    }\n\n    .shopify-geo__city-map {\n      height: 100%;\n      min-height: 260px;\n    }\n\n    .shopify-geo__city-map--maplibre {\n      height: 100%;\n\n      .followers-maplibre--shopify-geo,\n      .followers-maplibre--shopify-geo .followers-maplibre__canvas {\n        min-height: 260px;\n        height: 100%;\n      }\n    }\n\n    .shopify-geo__heatmap-wrap {\n      flex: 1 1 auto;\n      min-height: 0;\n    }\n\n    .shopify-geo__panel h4 {\n      margin-bottom: 10px;\n    }\n\n    .shopify-geo__panel-title-text {\n      white-space: normal;\n      overflow: visible;\n      text-overflow: unset;\n    }\n\n    .shopify-geo__product-bars-block {\n      min-height: 0;\n      height: 100%;\n      margin-top: 0;\n      justify-content: flex-start;\n    }\n  }\n\n  &__panels-row {\n    display: contents;\n  }\n\n  &__region-top {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    padding-bottom: 6px;\n    border-bottom: 1px solid #c6c9cd;\n\n    h3 {\n      margin: 0;\n      font-size: 12px !important;\n      font-weight: 400;\n      color: #5a5e62;\n    }\n\n    .definition-tooltip {\n      margin-left: auto;\n      flex: 0 0 auto;\n    }\n  }\n\n  &__region-top--filtered {\n    align-items: flex-start;\n    padding-bottom: 8px;\n  }\n\n  &__region-heading {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    min-width: 0;\n    flex: 1 1 auto;\n\n    h3 {\n      margin: 0;\n      font-size: 15px !important;\n      font-weight: 600 !important;\n      color: #17325c;\n      line-height: 1.25;\n      overflow-wrap: anywhere;\n    }\n  }\n\n  &__region-badge {\n    display: inline-flex;\n    align-items: center;\n    width: fit-content;\n    max-width: 100%;\n    font-size: 10px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    color: #4a6282;\n    background: rgba(43, 116, 228, 0.1);\n    border: 1px solid rgba(43, 116, 228, 0.22);\n    border-radius: 999px;\n    padding: 2px 8px;\n    line-height: 1.35;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &--time {\n      color: #6b4c9a;\n      background: rgba(141, 79, 211, 0.1);\n      border-color: rgba(141, 79, 211, 0.24);\n    }\n  }\n\n  &__region-icon {\n    width: 34px;\n    height: 34px;\n    background: $shopify-geo-chart-primary;\n    opacity: 0.95;\n    flex-shrink: 0;\n  }\n\n  &__region-icon--punjab {\n    clip-path: polygon(33% 4%, 58% 10%, 76% 24%, 93% 44%, 87% 64%, 68% 82%, 40% 95%, 18% 92%, 7% 72%, 16% 56%, 11% 36%, 24% 14%);\n  }\n\n  &__region-icon--sindh {\n    clip-path: polygon(37% 7%, 60% 10%, 74% 22%, 79% 42%, 72% 59%, 74% 79%, 57% 87%, 34% 86%, 24% 68%, 19% 47%, 23% 24%);\n  }\n\n  &__region-icon--balochistan {\n    clip-path: polygon(11% 36%, 30% 43%, 50% 40%, 66% 33%, 84% 25%, 92% 37%, 87% 57%, 68% 64%, 47% 69%, 27% 68%, 13% 58%);\n  }\n\n  &__region-icon--kpk {\n    clip-path: polygon(42% 5%, 61% 11%, 77% 24%, 76% 42%, 64% 53%, 62% 70%, 51% 88%, 35% 86%, 28% 70%, 17% 57%, 19% 34%, 28% 16%);\n  }\n\n  &__region-icon--ajk {\n    clip-path: polygon(38% 5%, 55% 10%, 72% 23%, 91% 45%, 84% 66%, 61% 80%, 41% 94%, 31% 85%, 29% 70%, 16% 54%, 21% 35%, 27% 17%);\n  }\n\n  &__region-icon--others {\n    border-radius: 8px;\n    clip-path: none;\n    background: #8a96a8;\n  }\n\n  &__metrics-grid {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 6px;\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__metric-card {\n    background: $white;\n    border-radius: 7px;\n    padding: 6px;\n    min-height: 96px;\n    min-width: 0;\n    overflow: visible;\n    position: relative;\n  }\n\n  &__metric-card:last-child:nth-child(odd) {\n    grid-column: 1 / -1;\n\n    .shopify-geo__spark-wrap svg {\n      height: 34px;\n    }\n  }\n\n  &__metric-card:hover,\n  &__metric-card:focus-within {\n    z-index: 7;\n  }\n\n  &__metric-card--selectable {\n    cursor: pointer;\n    outline: 1px solid transparent;\n    transition:\n      outline-color 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      outline-color: rgba(43, 116, 228, 0.35);\n    }\n\n    &:focus {\n      outline: 2px solid rgba(43, 116, 228, 0.35);\n      outline-offset: 1px;\n    }\n  }\n\n  &__metric-card--active {\n    outline-color: $shopify-geo-chart-primary;\n    box-shadow: 0 0 0 1px $shopify-geo-chart-primary;\n  }\n\n  &__metric-title {\n    margin: 0;\n    color: #17325c;\n    font-size: 11px;\n    font-weight: 600;\n  }\n\n  &__metric-title-row {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 4px;\n    min-width: 0;\n\n    .definition-tooltip {\n      flex: 0 0 auto;\n    }\n  }\n\n  &__metric-value {\n    margin: 2px 0;\n    font-size: $font-size-sm;\n    color: #17325c;\n    line-height: 1.1;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n  }\n\n  &__metric-delta {\n    margin: 0;\n    font-size: 8px;\n    font-weight: 600;\n  }\n\n  &__metric-delta--positive {\n    color: #49904a;\n  }\n\n  &__metric-delta--negative {\n    color: #cc4a44;\n  }\n\n  &__spark-wrap {\n    margin-top: 4px;\n    position: relative;\n    overflow: hidden;\n\n    svg {\n      width: 100%;\n      height: 28px;\n      display: block;\n      overflow: hidden;\n      shape-rendering: geometricPrecision;\n    }\n  }\n\n  &__spark-line {\n    fill: none;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n  }\n\n  &__spark-vertex {\n    pointer-events: none;\n  }\n\n  &__spark-vertex--previous {\n    fill: rgba(148, 208, 181, 0.32);\n    stroke: $shopify-geo-chart-secondary;\n    stroke-width: 0.35;\n  }\n\n  &__spark-vertex--current {\n    fill: $shopify-geo-chart-primary;\n    stroke: $shopify-geo-chart-warning;\n    stroke-width: 0.35;\n  }\n\n  &__spark-line--previous {\n    stroke: $shopify-geo-chart-secondary;\n  }\n\n  &__spark-line--current {\n    stroke: $shopify-geo-chart-primary;\n  }\n\n  &__spark-dot {\n    stroke-width: 1.5;\n  }\n\n  &__spark-dot--previous {\n    fill: rgba(148, 208, 181, 0.22);\n    stroke: $shopify-geo-chart-secondary;\n  }\n\n  &__spark-dot--current {\n    fill: $shopify-geo-chart-primary;\n    stroke: $shopify-geo-chart-warning;\n  }\n\n  &__panel {\n    background: $white;\n    border: 1px solid #dde1e4;\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: visible;\n    min-height: 0;\n    height: 100%;\n\n    h4 {\n      margin: 0 0 8px;\n      font-size: 11px;\n      font-weight: 400;\n      color: #4d545e;\n      min-height: 24px;\n      line-height: 1.25;\n      display: grid;\n      grid-template-columns: minmax(0, 1fr) auto;\n      align-items: start;\n      gap: 6px;\n      width: 100%;\n      margin-bottom: 15px;\n    }\n  }\n\n  &__panel-title-text {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__region:last-child .definition-tooltip__popover {\n    left: auto;\n    right: 0;\n  }\n\n  &__city-map {\n    height: 170px;\n    position: relative;\n    overflow: hidden;\n    background: $white;\n  }\n\n  &__city-map--maplibre {\n    border: 1px solid #e6ebf2;\n    border-radius: 4px;\n\n    .followers-maplibre--shopify-geo,\n    .followers-maplibre--shopify-geo .followers-maplibre__canvas {\n      min-height: 170px;\n      height: 100%;\n    }\n\n    .followers-maplibre--shopify-geo {\n      border-radius: 4px;\n      box-shadow: none;\n    }\n\n    .maplibregl-ctrl-top-right {\n      top: 6px;\n      right: 6px;\n    }\n  }\n\n  &__city-map--not-available {\n    width: 170px;\n    max-width: 100%;\n    margin: 0 auto;\n    border: 1px dashed #c6cfdc;\n    border-radius: 4px;\n    background: #f7f9fc;\n    color: #6b778c;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    text-align: center;\n    aspect-ratio: 1 / 1;\n    height: auto;\n    min-height: 0;\n  }\n\n  &__city-marker {\n    display: block;\n    border-radius: 999px;\n    background: rgba(148, 208, 181, 0.28);\n    border: 2px solid $shopify-geo-chart-secondary;\n    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.45);\n    cursor: pointer;\n  }\n\n  &__blob {\n    width: 86%;\n    height: 88%;\n    margin: 12px auto 0;\n    background: $shopify-geo-chart-primary;\n    clip-path: polygon(11% 75%, 21% 56%, 15% 36%, 27% 20%, 44% 13%, 63% 16%, 79% 27%, 92% 45%, 86% 66%, 72% 83%, 52% 94%, 31% 91%);\n  }\n\n  &__blob--all {\n    clip-path: polygon(33% 4%, 58% 10%, 76% 24%, 93% 44%, 87% 64%, 68% 82%, 40% 95%, 18% 92%, 7% 72%, 16% 56%, 11% 36%, 24% 14%);\n  }\n\n  &__blob--punjab {\n    clip-path: polygon(33% 4%, 58% 10%, 76% 24%, 93% 44%, 87% 64%, 68% 82%, 40% 95%, 18% 92%, 7% 72%, 16% 56%, 11% 36%, 24% 14%);\n  }\n\n  &__blob--sindh {\n    clip-path: polygon(37% 7%, 60% 10%, 74% 22%, 79% 42%, 72% 59%, 74% 79%, 57% 87%, 34% 86%, 24% 68%, 19% 47%, 23% 24%);\n  }\n\n  &__blob--balochistan {\n    clip-path: polygon(11% 36%, 30% 43%, 50% 40%, 66% 33%, 84% 25%, 92% 37%, 87% 57%, 68% 64%, 47% 69%, 27% 68%, 13% 58%);\n  }\n\n  &__blob--kpk {\n    clip-path: polygon(42% 5%, 61% 11%, 77% 24%, 76% 42%, 64% 53%, 62% 70%, 51% 88%, 35% 86%, 28% 70%, 17% 57%, 19% 34%, 28% 16%);\n  }\n\n  &__blob--ajk {\n    clip-path: polygon(38% 5%, 55% 10%, 72% 23%, 91% 45%, 84% 66%, 61% 80%, 41% 94%, 31% 85%, 29% 70%, 16% 54%, 21% 35%, 27% 17%);\n  }\n\n  &__bubble {\n    position: absolute;\n    border-radius: 50%;\n    background: rgba(246, 193, 95, 0.18);\n    border: 2px solid $shopify-geo-chart-tertiary;\n  }\n\n  &__bubble--lg {\n    width: 36px;\n    height: 36px;\n    right: 22%;\n    top: 52%;\n  }\n\n  &__bubble--md {\n    width: 20px;\n    height: 20px;\n    right: 36%;\n    top: 24%;\n  }\n\n  &__bubble--sm {\n    width: 11px;\n    height: 11px;\n    right: 31%;\n    top: 20%;\n  }\n\n  &__heatmap-wrap {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n    height: 100%;\n    overflow-x: auto;\n    position: relative;\n  }\n\n  &__heat-days {\n    display: grid;\n    grid-template-columns: 46px repeat(7, 1fr);\n    gap: 2px;\n    margin-bottom: 2px;\n\n    span {\n      font-size: $font-size-xs;\n      text-align: center;\n      color: #17325c;\n    }\n  }\n\n  &__heat-body {\n    display: grid;\n    gap: 2px;\n  }\n\n  &__heat-row {\n    position: relative;\n    display: grid;\n    grid-template-columns: 46px repeat(7, 1fr);\n    gap: 2px;\n\n    span {\n      font-size: 9px;\n      color: #17325c;\n      line-height: 14px;\n      text-align: right;\n      padding-right: 7px;\n      white-space: nowrap;\n    }\n  }\n\n  &__heat-cell {\n    height: 14px;\n    border-radius: 1px;\n    cursor: pointer;\n  }\n\n  &__heat-cell--lv1 {\n    background: rgba($shopify-geo-chart-primary, 0.12);\n  }\n\n  &__heat-cell--lv2 {\n    background: rgba($shopify-geo-chart-primary, 0.28);\n  }\n\n  &__heat-cell--lv3 {\n    background: rgba($shopify-geo-chart-primary, 0.56);\n  }\n\n  &__heat-cell--lv4 {\n    background: rgba($shopify-geo-chart-primary, 0.88);\n  }\n\n  &__heat-cell--active {\n    box-shadow: 0 0 0 2px $shopify-geo-chart-primary;\n    z-index: 1;\n  }\n\n  &__donut-block {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    min-height: 240px;\n    height: 100%;\n    justify-content: center;\n  }\n\n  &__donut-wrap {\n    width: 126px;\n    height: 126px;\n    position: relative;\n  }\n\n  &__legend {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: grid;\n    gap: 6px;\n    width: 100%;\n    min-height: 118px;\n  }\n\n  &__donut-svg {\n    width: 126px;\n    height: 126px;\n    display: block;\n  }\n\n  &__donut-center {\n    background: #f2f4f6;\n    fill: #f2f4f6;\n  }\n\n  &__donut-segment {\n    cursor: pointer;\n    transition: opacity 0.15s ease;\n\n    &:hover {\n      opacity: 0.86;\n    }\n  }\n\n  &__donut-segment--selectable {\n    cursor: pointer;\n  }\n\n  &__product-bars-block {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-height: 170px;\n    height: 100%;\n    margin-top: -20px;\n  }\n\n  &__product-bars {\n    display: grid;\n    gap: 12px;\n    width: 100%;\n  }\n\n  &__product-bar-row {\n    display: grid;\n    gap: 4px;\n    width: 100%;\n    min-width: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    text-align: left;\n  }\n\n  &__product-bar-row--interactive {\n    cursor: pointer;\n  }\n\n  &__product-bar-row:hover .shopify-geo__product-bar-fill,\n  &__product-bar-row:focus-visible .shopify-geo__product-bar-fill {\n    filter: brightness(0.95) saturate(1.1);\n  }\n\n  &__product-bar-row:focus-visible {\n    outline: 2px solid rgba(43, 116, 228, 0.35);\n    outline-offset: 2px;\n  }\n\n  &__product-bar-meta {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n  }\n\n  &__product-bar-name {\n    min-width: 0;\n    color: #14243f;\n    font-size: 9px;\n    font-weight: 700;\n    line-height: 1.25;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__product-bar-meta strong {\n    color: #17325c;\n    font-size: 9px;\n    font-weight: 800;\n    line-height: 1;\n    white-space: nowrap;\n  }\n\n  &__product-bar-track {\n    display: block;\n    width: 100%;\n    height: 7px;\n    overflow: hidden;\n    border-radius: 999px;\n    background: #e9edf3;\n  }\n\n  &__product-bar-fill {\n    display: block;\n    height: 100%;\n    border-radius: inherit;\n    transition: filter 0.15s ease;\n  }\n\n  &__product-bars-empty {\n    margin: 0;\n    color: #6b7280;\n    font-size: 11px;\n    font-weight: 600;\n    text-align: center;\n  }\n\n  &__legend {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    display: grid;\n    gap: 6px;\n    width: 100%;\n\n    li {\n      display: grid;\n      grid-template-columns: 10px minmax(0, 1fr);\n      gap: 6px;\n      align-items: center;\n      border: 1px solid transparent;\n      padding: 2px 3px;\n\n      &:hover {\n        border-color: #8f8f8f;\n        background: rgba($white, 0.35);\n      }\n    }\n\n    span {\n      width: 10px;\n      height: 10px;\n      border-radius: 1px;\n    }\n\n    p {\n      margin: 0;\n      font-size: 11px;\n      color: #4f5661;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n  }\n\n  .followers-maplibre--shopify-geo .followers-maplibre__tooltip {\n    max-width: calc(100vw - 16px);\n    transform: none;\n  }\n\n  .followers-maplibre--shopify-geo .shopify-geo-map-tooltip {\n    gap: 10px;\n    min-width: 70px;\n    max-width: 100px;\n    padding: 22px 22px 22px;\n    border: 1px solid #e6ebf2;\n    border-radius: 12px;\n    background: #ffffff;\n    box-shadow:\n      0 1px 2px rgba(15, 23, 42, 0.08),\n      0 14px 34px rgba(15, 23, 42, 0.18);\n  }\n\n  .shopify-geo-map-tooltip__title {\n    color: $shopify-geo-chart-primary;\n    font-size: 16px;\n    font-weight: 800;\n    line-height: 1.15;\n  }\n\n  .shopify-geo-map-tooltip__row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    min-width: 0;\n    color: #7b8497;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.2;\n  }\n\n  .shopify-geo-map-tooltip__label {\n    min-width: 0;\n    white-space: nowrap;\n  }\n\n  .shopify-geo-map-tooltip__value {\n    color: #697386;\n    font-weight: 800;\n    white-space: nowrap;\n    text-align: right;\n  }\n}\n\n// Portaled to document.body (see ShopifyGeoSpatialDashboard.tsx) so `position: fixed`\n// resolves against the real viewport, not the `container-type` ancestors above,\n// which would otherwise become the containing block and misplace the tooltip.\n.analytics-chart-tooltip {\n  position: absolute;\n  transform: translateX(-50%);\n  display: flex;\n  background: $white;\n  border-radius: 8px;\n  border: 1px solid #d9e4f2;\n  box-shadow: 0 8px 18px rgba(30, 42, 70, 0.18);\n  overflow: hidden;\n  padding: 0;\n  z-index: 25;\n  pointer-events: none;\n\n  &__bar {\n    width: 4px;\n    background: $shopify-geo-chart-primary;\n    flex-shrink: 0;\n  }\n\n  &__content {\n    padding: 8px 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  &__meta {\n    font-size: 11px;\n    color: #5a6f91;\n    line-height: 1.25;\n\n    strong {\n      color: #1f2d42;\n      font-weight: 700;\n    }\n  }\n}\n\n.analytics-chart-tooltip--shopify-kpi {\n  position: fixed;\n  transform: none;\n  min-width: 220px;\n  max-width: calc(100vw - 16px);\n  height: auto;\n}\n\n.analytics-chart-tooltip--shopify-heatmap {\n  position: fixed;\n  transform: none;\n  width: 220px;\n  min-width: 220px;\n  max-width: 220px;\n  height: auto;\n}\n\n.analytics-chart-tooltip--shopify-products,\n.analytics-chart-tooltip--shopify-donut {\n  position: fixed;\n  transform: none;\n  min-width: 240px;\n  max-width: 320px;\n  height: auto;\n}\n\n@media (max-width: 1000px) {\n  .shopify-geo {\n    &__date-strip {\n      grid-template-columns: 1fr;\n      gap: 12px;\n    }\n\n    &__date-info {\n      grid-column: auto;\n\n      p {\n        white-space: normal;\n      }\n    }\n\n    &__date-inputs {\n      grid-column: auto;\n      justify-self: start;\n      justify-content: flex-start;\n      flex-wrap: wrap;\n      width: 100%;\n\n      .organic-range-picker {\n        width: 100%;\n      }\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .shopify-geo {\n    &__header h2 {\n      font-size: 24px;\n    }\n\n    &__date-strip {\n      display: flex;\n      flex-direction: column;\n      align-items: stretch;\n    }\n\n    &__date-inputs {\n      justify-content: flex-start;\n      flex-wrap: wrap;\n      gap: 10px;\n    }\n\n    &__date-info {\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      grid-column: auto;\n\n      p {\n        white-space: normal;\n        text-align: center;\n      }\n    }\n\n    &__regions-grid:not(&__regions-grid--single) {\n      grid-template-columns: 1fr;\n      grid-auto-flow: row;\n      grid-auto-columns: auto;\n      min-width: 0;\n    }\n  }\n}\n\n/* ResizeObserver-driven layout (devtools / sidebar) — reliable vs viewport media queries */\n.shopify-geo__main--wide {\n  .shopify-geo__region--focused .shopify-geo__metrics-grid {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n}\n\n.shopify-geo__main--compact {\n  .shopify-geo__regions-grid:not(.shopify-geo__regions-grid--single) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .shopify-geo__region--focused .shopify-geo__metrics-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .shopify-geo__region--focused .shopify-geo__panels-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .shopify-geo__region--focused .shopify-geo__city-map {\n    height: 220px;\n    min-height: 220px;\n  }\n\n  .shopify-geo__region--focused .shopify-geo__city-map--maplibre {\n    .followers-maplibre--shopify-geo,\n    .followers-maplibre--shopify-geo .followers-maplibre__canvas {\n      min-height: 220px;\n      height: 220px;\n    }\n  }\n}\n\n.shopify-geo__main--stacked {\n  .shopify-geo__regions-grid:not(.shopify-geo__regions-grid--single) {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .shopify-geo__region--focused .shopify-geo__metrics-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .shopify-geo__region--focused .shopify-geo__panels-row {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .shopify-geo__region--focused .shopify-geo__city-map {\n    height: 220px;\n    min-height: 220px;\n  }\n\n  .shopify-geo__region--focused .shopify-geo__city-map--maplibre {\n    .followers-maplibre--shopify-geo,\n    .followers-maplibre--shopify-geo .followers-maplibre__canvas {\n      min-height: 220px;\n      height: 220px;\n    }\n  }\n}\n\n.shopify-geo__main--compact,\n.shopify-geo__main--stacked {\n  .shopify-geo__region:not(.shopify-geo__region--focused) .shopify-geo__metrics-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n@container geo-region (max-width: 300px) {\n  .shopify-geo__metrics-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .shopify-geo__metric-card:last-child:nth-child(odd) {\n    grid-column: auto;\n  }\n}\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
